const ARTICLES = new Set(["the", "le", "la", "les", "l", "un", "une", "a", "an", "el", "los", "las", "der", "die", "das"]);
export function normalizeBingoText(value) {
    const stripped = value
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{M}/gu, "")
        .replace(/&/g, " et ")
        .replace(/[^a-z0-9]+/gi, " ")
        .replace(/\s+/g, " ")
        .trim();
    const words = stripped.split(" ").filter(Boolean);
    while (words.length > 1 && ARTICLES.has(words[0])) {
        words.shift();
    }
    return words.join(" ");
}
/** Distance de Damerau-Levenshtein (substitution, insertion, suppression, inversion adjacente). */
export function damerauLevenshtein(a, b) {
    if (a === b)
        return 0;
    const la = a.length;
    const lb = b.length;
    if (la === 0)
        return lb;
    if (lb === 0)
        return la;
    const prevPrev = new Array(lb + 1);
    const prev = new Array(lb + 1);
    const curr = new Array(lb + 1);
    for (let j = 0; j <= lb; j += 1)
        prev[j] = j;
    for (let i = 1; i <= la; i += 1) {
        curr[0] = i;
        for (let j = 1; j <= lb; j += 1) {
            const cost = a[i - 1] === b[j - 1] ? 0 : 1;
            curr[j] = Math.min((prev[j] ?? 0) + 1, (curr[j - 1] ?? 0) + 1, (prev[j - 1] ?? 0) + cost);
            if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
                curr[j] = Math.min(curr[j], (prevPrev[j - 2] ?? 0) + 1);
            }
        }
        for (let j = 0; j <= lb; j += 1) {
            prevPrev[j] = prev[j];
            prev[j] = curr[j];
        }
    }
    return prev[lb];
}
export function textsMatch(expected, given) {
    const a = normalizeBingoText(expected);
    const b = normalizeBingoText(given);
    if (!a || !b)
        return false;
    if (a === b)
        return true;
    const maxLen = Math.max(a.length, b.length);
    if (maxLen < 3)
        return false;
    if (Math.abs(a.length - b.length) > 1)
        return false;
    return damerauLevenshtein(a, b) <= 1;
}
export function asTrimmedString(value) {
    if (typeof value === "string") {
        const t = value.trim();
        return t.length ? t : null;
    }
    if (typeof value === "number" && Number.isFinite(value))
        return String(value);
    return null;
}
export function asYear(value) {
    if (typeof value === "number" && Number.isInteger(value))
        return value;
    if (typeof value === "string" && /^-?\d+$/.test(value.trim()))
        return Number(value.trim());
    return null;
}
